import { useTheme } from "@mui/material";
import { useFlatRowRedesign } from "web_myplann/Shared/Hooks/useFlatRowRedesign";

export const useFlatRowValueColor = (disabled = false): string => {
	const { palette } = useTheme();
	const isRedesign = useFlatRowRedesign();

	if (disabled) {
		return palette.grey[400];
	}

	return isRedesign ? palette.grey[900] : palette.blue[600];
};
